import { createApp } from 'vue'
import Inc from './Inc.vue'
import './assets/global.css'

createApp(Inc).mount('#inc')
